<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    사업장 정보-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 사업장 정보</h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업내용</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
        <vs-input
          v-else
          v-model="form.inputB_1"
          class="w-full flex-1"
        ></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">조사일</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
        <date-selector
          v-else
          class="w-full flex-1"
          v-model="form.inputB_5"
          :readonly="board.readonly"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업자</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <vs-input
          v-else
          v-model="form.inputB_4"
          class="w-full flex-1"
        ></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">수행일시</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
        <date-selector
          v-else
          class="w-full flex-1"
          v-model="form.inputB_2"
          :readonly="board.readonly"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">확인자</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
        <vs-input
          v-else
          v-model="form.inputB_3"
          class="w-full flex-1"
        ></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검장소</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
        <vs-input
          v-else
          v-model="form.inputB_6"
          class="w-full flex-1"
        ></vs-input>
      </div>
    </div>

    <!--    유해·위험요인 조사-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 유해·위험요인 조사</h5>
      </vs-col>
    </vs-row>

    <div class="print-container flex items-start mt-4">
      <div class="label-text mr-4 mt-2">작업내용</div>
      <p v-if="isPrint" class="print-textarea">{{ form.inputC_1 }}</p>
      <vs-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputC_1"
        class="flex-1 w-full"
        rows="5"
      />
    </div>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장소</div>
        <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
        <vs-input
          v-else
          v-model="form.inputC_2"
          class="w-full flex-1"
        ></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">위험정도</div>
        <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>
        <vs-input
          v-else
          v-model="form.inputC_3"
          class="w-full flex-1"
        ></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">사고유형</div>
        <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
        <vs-input
          v-else
          v-model="form.inputC_4"
          class="w-full flex-1"
        ></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">질병유형</div>
        <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>
        <vs-input
          v-else
          v-model="form.inputC_5"
          class="w-full flex-1"
        ></vs-input>
      </div>
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (
          !this.form ||
          !this.form.inspectList ||
          this.form.inspectList.length === 0
        ) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "다목적 체육관",

      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",

        photoList: [],
        fileList: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
